import { render, staticRenderFns } from "./TaskCount.vue?vue&type=template&id=35fe118c&"
import script from "./TaskCount.vue?vue&type=script&lang=js&"
export * from "./TaskCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports